var map = {
	"./contact/DetailPanel": 1036,
	"./cpo/DetailPanel": 1037,
	"./customer/DetailPanel": 1038,
	"./forwarderPo/DetailPanel": 1107,
	"./incomingInvoice/DetailPanel": 1039,
	"./incomingPayment/DetailPanel": 1040,
	"./outgoingInvoice/DetailPanel": 1041,
	"./outgoingPayment/DetailPanel": 1042,
	"./outgoingQuote/DetailPanel": 1043,
	"./product/DetailPanel": 1044,
	"./receiving/DetailPanel": 1045,
	"./shipping/DetailPanel": 1046,
	"./spo/DetailPanel": 1108,
	"./vendor/DetailPanel": 1047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1035;